export default __webpack_public_path__ + "static/media/img.fd2e0512.svg";